<app-loader [hideSpinner]="isDataLoaded"></app-loader>
<div [ngClass]="{ 'hidden': !isDataLoaded }" class="product-view-container">
	<nav class="product-header sticky-top navbar navbar-light bg-light" [ngClass]="{ 'im-dirty': isModified }">
		<span class="navbar-brand">Zone View</span>
		<div class="navbar-nav mr-auto"></div>
		<button type="button" class="btn btn-secondary btn-cancel mr-1" (click)="cancel()">
			<span>Reset Form</span>
		</button>
		<button type="button" class="btn btn-primary btn-save mr-1" (click)="save()">
			<span>Save</span>
		</button>
		<button type="button" class="btn btn-danger btn-delete mr-1" (click)="delete()">
			<span>Delete</span>
		</button>
		<button *ngIf="zone.active" type="button" class="btn btn-warning btn-deactivate mr-1" (click)="deactivate()">
			<span>Deactivate</span>
		</button>
		<button *ngIf="!zone.active" type="button" class="btn btn-primary btn-activate mr-1" (click)="activate()">
			<span>Activate</span>
		</button>
		<button mat-icon-button class="btn-close" (click)="back()">
			<mat-icon>close</mat-icon>
		</button>
	</nav>
	<div class="product-container">
		<mat-card class="mb-3">
			<div class="row">
				<div class="col-8">
					<label>Zone Name</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="zone.name" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>Zone Code</label>
					<div class="input-group mb-3">
						<input [(ngModel)]="zone.code" type="text" class="form-control" (input)="dataChanged()">
					</div>
					<label>Courier</label>
					<select [(ngModel)]="zone.courierId" name="courierId" class="custom-select" required>
						<option value="0">Select a courier</option>
						<option *ngFor="let courier of couriers" value="{{courier.id}}">{{ courier.name }}</option>
					</select>
					<label>Description</label>
					<div class="input-group mb-3">
						<textarea [(ngModel)]="zone.description" class="form-control" rows="5"
							(input)="dataChanged()"></textarea>
					</div>
				</div>
			</div>
		</mat-card>
		<mat-card>
			<span class="navbar-brand">Prices</span>
			<button type="button" class="btn btn-primary btn-save" (click)="addPrice()">
				<span>Add Price</span>
			</button>
			<mat-table [dataSource]="dataSource" matSort matSortActive="Id" matSortDirection="asc">
				<ng-container matColumnDef="Id">
					<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
					<mat-cell *matCellDef="let row" (click)="viewPrice(row.id)"> {{row.id}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="Weight">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Weight </mat-header-cell>
					<mat-cell *matCellDef="let row" (click)="viewPrice(row.id)">
						<span>{{row.weight}}g</span>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="Amount">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Amount </mat-header-cell>
					<mat-cell *matCellDef="let row" (click)="viewPrice(row.id)"> {{row.amount}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="Active">
					<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
					<mat-cell *matCellDef="let row" (click)="viewPrice(row.id)"> {{row.active ? 'Active' : 'Inactive'}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="Buttons">
					<mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
					<mat-cell *matCellDef="let row" >
						<button mat-icon-button class="btn-close" (click)="deletePrice(row.id)">
							<mat-icon>close</mat-icon>
						</button>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
			</mat-table>

			<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
		</mat-card>
	</div>
</div>